import { Field, RichTextField, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import type { ComponentProps } from 'lib/component-props';
import { PlanYear } from '../Types/PlanYear.Type';
import { PlanType } from '../Types/PlanTypes.Type';
import { DrugCoverageTableGroup } from '../Types/DrugCoverageTables.Type';

export type PlanDetailRowsOrder = {
  id: string;
  sortOrder: number;
};

export type PlanDetailGroupOrder = {
  id: string;
  caption: string;
};

export type PlanDetailsProps = ComponentProps & {
  fields: {
    searchpageurl: string;
    optionspageurl: string;
    planYears: PlanYear[];
    planType: PlanType;
    showPlanDocuments: Field<boolean>;
    showAdditionalBenefits: Field<boolean>;
    crmPrefix: string;
    planDetailGroupOrder: PlanDetailGroupOrder[];
    planDetailRowsOrder: PlanDetailRowsOrder[];
    drugCoverageTableGroups: DrugCoverageTableGroup[];
    useCavulus: boolean;
  };
};

export type PrescriptionDrugTables = {
  targetId: string;
  targetItem: PrescriptionDrugTablesTargetItem;
};

export type PrescriptionDrugTablesTargetItem = {
  groupCaption: TextField;
  planComparisonTableHeader: TextField;
  drugCoverageTable: {
    results: DrugCoverageTable[];
  };
};

export type DrugCoverageTable = {
  drugCoverageTableCaption: TextField;
  children: {
    results: (DrugCoverageColumnGroup | DrugCoverageTableRow)[];
  };
};

export type DrugCoverageColumnGroup = {
  children: {
    results: DrugCoverageColumn[];
  };
};

export type DrugCoverageColumn = {
  templateType: string;
  columnColor: {
    targetItem: {
      field: {
        value: string;
      };
    };
  };
};

export type DrugCoverageTableRow = {
  children: {
    results: DrugCoverageTableCell[];
  };
};

export type DrugCoverageTableCell = {
  templateType: string;
  isHeader: {
    boolValue: boolean;
  };
  label: {
    jsonValue: RichTextField;
  };
};
